/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

const pageSize = 10;
const pageLimit = 1;

import { AnimatePresence, motion } from "framer-motion";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoMdArrowBack, IoMdMic } from "react-icons/io";
import { useLocation, useNavigation, useParams } from "react-router";

import { LuSearch } from "react-icons/lu";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { touchVariants } from "~/lib/motion-obj";
import {
  getSearchModule,
  getSearchResults,
  setClearSearchResults,
  setOpenToSearch,
  setSearchHistory,
  setSearchText,
  setSelectedTab,
} from "~/lib/store/slice/searchSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { COLORS, FALLBACK_IMAGE_URL, ICON_ORANGE_COLOR, LANG } from "~/utils/constant";

import { CircularProgress } from "@mui/material";
import { MdOutlineClose, MdStop } from "react-icons/md";
import { useIsMobile } from "~/hook/use-mobile";
import { useFontStyle } from "~/hook/useFontStyle";
import useLocale from "~/hook/useLocale";
import { isIOS, removeUnderscore, truncateString } from "~/utils/helper-funcations";
// import ClientOnly from "./ClentOnly";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from "lucide-react";
import ListImage from "./search/ListImage";
import { getRecentSearch, RECENT_SEARCHES_KEY, RecentSearch, setLocalStorageRecentSearch, setSearchStrToLocalStorage } from "./search/search-service";
import SearchList from "./search/SearchList";
import { QueryParams, SearchHistoryPayload, SearchItem } from "./search/type";

const shortcutListenerAdded = { current: false };

const SearchBar = ({
  className,
  width,
  isSticky,
  isMenu = false,
  isSupperHeader = false,
  isYoutubeVideoLayout = false,
}: {
  className?: string;
  width?: string;
  isSticky?: boolean;
  isMenu?: boolean;
  isSupperHeader?: boolean;
  isYoutubeVideoLayout?: boolean;
}) => {
  const isMobile = useIsMobile();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { lang } = useParams();
  const navigationStatus = useNavigation();
  const { t } = useTranslation();
  const { navigate } = useLocale();
  const { medium, normalInter } = useFontStyle();
  const { isSupperHeader: supperHeader } = useAppSelector((state) => state.header);

  const SELECTED_MODULE_ALL = lang === LANG.english ? "All" : "બધા";

  const itemRefs = useRef<(HTMLLIElement | null)[]>([]);
  const triggerRef = useRef<HTMLDivElement | null>(null);
  const panelRef = useRef<HTMLDivElement | null>(null);
  const searchInputRef = useRef<HTMLInputElement | null>(null);
  const speechTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const speechStartTimeRef = useRef<number | null>(null);
  const lastTranscriptRef = useRef<string>("");
  const lastSearchRequestRef = useRef<string>("");
  const tabsContainerRef = useRef<HTMLDivElement | null>(null);
  const tabButtonRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const searchResultsRef = useRef<HTMLDivElement | null>(null);

  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
  const { isLoading, searchResults, hasMoreResults, allModule, hasMoreAllModule, searchText, selectedTab } = useAppSelector((state) => state.search);
  const { module } = useAppSelector((state) => state.search);
  const MODULE = [...(Array.isArray(module) ? module.map((m) => (lang === LANG.english ? m.en_name : m.gu_name)) : [])];

  // Track hydration to prevent mismatch with voiceSearchSupported
  const [isHydrated, setIsHydrated] = useState(false);
  const [voiceSearchSupported, setVoiceSearchSupported] = useState(false);

  // const [searchText, setSearchText] = useState(getSearchStrFromLocalStorage() || "");
  // const [selectedTab, setSelectedTab] = useState(SELECTED_MODULE_ALL);

  const [open, setOpen] = useState(false);
  const [searchType, setSearchType] = useState<"text" | "voice">("text");
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [recentSearches, setRecentSearches] = useState<RecentSearch[]>(getRecentSearch() || []);

  const [showAllTabs, setShowAllTabs] = useState(() => {
    const defaultVisibleTabs = MODULE?.slice(0, 6);
    return defaultVisibleTabs?.includes(selectedTab);
  });

  const [pageDetails, setPageDetails] = useState<{ pageNumber: number; limit: number }>({
    pageNumber: pageLimit,
    limit: pageSize,
  });

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // On mobile, always show all tabs for horizontal scrolling. On desktop, respect showAllTabs
  const visibleTabs = isMobile ? MODULE : showAllTabs ? MODULE : MODULE?.slice(0, 6);

  // Set voiceSearchSupported only after hydration to prevent mismatch
  useEffect(() => {
    setIsHydrated(true);
    setVoiceSearchSupported(browserSupportsSpeechRecognition && !isIOS());
  }, [browserSupportsSpeechRecognition]);

  const combinedList = [
    ...(searchText === "" && recentSearches.length > 0 ? recentSearches : []),
    ...(searchResults?.rows || []),
    ...((allModule && allModule.rows) || []),
  ];

  const listData = searchResults && searchResults?.rows?.length > 0 ? searchResults.rows : allModule?.rows || [];
  const hasResults = listData.length > 0;
  const showNoResultsNote =
    (!searchResults?.rows?.length || searchResults.rows.length === 0) && allModule && allModule?.count > 0 && selectedTab !== SELECTED_MODULE_ALL;

  const loadMore = useCallback(async () => {
    // Prevent infinite API calls while data is loading
    if (isLoading) return;

    setPageDetails((prev) => {
      const nextPage = prev.pageNumber + 1;
      const payload: QueryParams = {
        search_text: searchText || "",
        module_name: selectedTab === SELECTED_MODULE_ALL ? null : selectedTab,
        pageNumber: nextPage,
        limit: prev.limit,
      };
      if (hasMoreResults) {
        dispatch(getSearchResults(payload));
        return { ...prev, pageNumber: nextPage };
      }

      if (hasMoreAllModule && selectedTab !== SELECTED_MODULE_ALL) {
        dispatch(getSearchResults(payload));
        return { ...prev, pageNumber: nextPage };
      }
      return prev;
    });
  }, [isLoading, hasMoreResults, hasMoreAllModule, searchText, selectedTab, dispatch]);

  const resetFromTextBox = () => {
    setSearchStrToLocalStorage("");
    dispatch(setSearchText(""));
    setActiveIndex(-1);
    dispatch(setClearSearchResults());
    setPageDetails({ pageNumber: pageLimit, limit: pageSize });
  };

  const addSearchParams = (value: string) => {
    if (value) setSearchStrToLocalStorage(value);
    else resetFromTextBox();
  };

  const checkScrollPosition = useCallback(() => {
    if (!tabsContainerRef.current) return;
    const container = tabsContainerRef.current;

    // Check if container has scrollable content
    const isScrollable = container.scrollWidth > container.clientWidth;

    if (!isScrollable) {
      setCanScrollLeft(false);
      setCanScrollRight(false);
      return;
    }

    const hasLeftScroll = container.scrollLeft > 2;
    const hasRightScroll = container.scrollLeft < container.scrollWidth - container.clientWidth - 2;

    setCanScrollLeft(hasLeftScroll);
    setCanScrollRight(hasRightScroll);
  }, []);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const _value = e.target.value;
    dispatch(setSearchText(_value));
    setActiveIndex(-1);
    setSearchType("text");
    if (_value !== "") addSearchParams(_value);
    else resetFromTextBox();
  };

  const handleClearSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(setSearchText(""));
    resetTranscript();
    setSearchStrToLocalStorage("");
    setActiveIndex(-1);
    resetFromTextBox();

    // Stop listening if active
    if (listening) {
      try {
        SpeechRecognition.stopListening();
      } catch (err) {
        console.error("Error stopping speech recognition:", err);
      }
    }

    if (speechTimeoutRef.current) {
      clearTimeout(speechTimeoutRef.current);
      speechTimeoutRef.current = null;
    }
  };

  const handleStopVoiceSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    try {
      SpeechRecognition.stopListening();
    } catch (err) {
      console.error("Error stopping speech recognition:", err);
    }
    if (speechTimeoutRef.current) {
      clearTimeout(speechTimeoutRef.current);
      speechTimeoutRef.current = null;
    }
    resetTranscript();
  };

  function onClose() {
    setOpen(false);
    lastSearchRequestRef.current = "";
    dispatch(setOpenToSearch(false));
    dispatch(setClearSearchResults());

    // Stop listening and clear timeout
    if (listening) {
      try {
        SpeechRecognition.stopListening();
      } catch (err) {
        console.error("Error stopping speech recognition:", err);
      }
    }

    if (speechTimeoutRef.current) {
      clearTimeout(speechTimeoutRef.current);
      speechTimeoutRef.current = null;
    }

    resetTranscript();
  }

  const { navigate: remixNavigate } = useLocale();

  const handleNavigate = useCallback(
    (url: string) => {
      if (!url) return;
      if (typeof window !== "undefined" && window?.closeSheet) window.closeSheet();
      remixNavigate(url, { replace: true });
    },
    [remixNavigate],
  );

  const handleApplySearch = (data: SearchItem, index: number) => {
    const payloadForHistory: SearchHistoryPayload = {
      search: searchText || "",
      search_type: searchType,
      index,
      search_module: data.mdl,
      mdl: data.mdl,
      sm: data.sm,
      et: data.et,
      gt: data.gt,
      ss: data.ss || "",
      p: data.p || 0,
    };
    dispatch(setSearchHistory(payloadForHistory));
    handleNavigate(data.url);
    if (searchText === "") return;
    const recentSearchData: RecentSearch = {
      name: LANG.gujarati === lang ? data.gt : data.et,
      url: data.url,
      image: data.img.url || "",
      query: searchText || "",
      module: data.mdl,
    };

    const handleUpdateRecentSearches = (prev: RecentSearch[]) => {
      const updated = prev.filter((s) => s.query !== searchText && s.url !== recentSearchData.url);
      return [recentSearchData, ...updated].slice(0, 10);
    };
    setRecentSearches(handleUpdateRecentSearches);
    setLocalStorageRecentSearch(recentSearchData);
  };

  const onSelectedSearch = (tab: string, e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (tab === selectedTab) return;
    // Reset page details when changing module
    setPageDetails({ pageNumber: pageLimit, limit: pageSize });
    // Clear old results immediately to prevent loadMore from being called with old data
    dispatch(setClearSearchResults());
    dispatch(setSelectedTab(tab));
    // Refocus input to keep keyboard open on mobile - use requestAnimationFrame for immediate effect
    requestAnimationFrame(() => {
      searchInputRef.current?.focus();
      // On mobile, ensure keyboard stays visible
      if (isMobile) {
        searchInputRef.current?.click?.();
      }
    });
  };

  const handleMicClick = async () => {
    if (!voiceSearchSupported) {
      alert("Your browser does not support speech recognition.");
      return;
    }

    // Always stop any existing listening session first
    try {
      SpeechRecognition.stopListening();
    } catch (err) {
      // Silently ignore if already stopped
    }

    // Clear any existing timeout
    if (speechTimeoutRef.current) {
      clearTimeout(speechTimeoutRef.current);
      speechTimeoutRef.current = null;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach((track) => track.stop());
      setSearchType("voice");
      resetTranscript();
      dispatch(setSelectedTab(getMatchedTabForCurrentRoute()));
      setOpen(true);
      setRecentSearches(getRecentSearch() || []);
      dispatch(setOpenToSearch(true));

      // Reset tracking refs
      speechStartTimeRef.current = Date.now();
      lastTranscriptRef.current = "";

      // Add a small delay to ensure proper initialization
      setTimeout(() => {
        try {
          // Use en-US for better iOS compatibility, fallback from gu-IN
          // const language = lang === LANG.english ? "en-US" : "gu-IN";
          const language = "gu-IN";
          SpeechRecognition.startListening({
            continuous: true,
            interimResults: true,
            language: language,
          });

          // Set timeout to stop listening after 15 seconds on mobile, 20 on desktop
          const timeoutDuration = isMobile ? 15000 : 20000;
          speechTimeoutRef.current = setTimeout(() => {
            try {
              SpeechRecognition.stopListening();
            } catch (err) {
              console.error("Error stopping speech recognition:", err);
            }
          }, timeoutDuration);
        } catch (err) {
          console.error("Error starting speech recognition:", err);
          alert("Failed to start voice recognition. Please try again.");
        }
      }, 100);
    } catch (error) {
      console.error("Microphone access error:", error);
      alert("Please allow microphone access to use voice search.");
    }
  };

  const handleClearRecentSearches = (e: React.MouseEvent, item: RecentSearch) => {
    e.stopPropagation();
    const _recentSearches = recentSearches.filter((search) => search.url !== item.url);
    setRecentSearches(_recentSearches);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(_recentSearches));
  };

  const keyDownCallback = useCallback(
    (e: KeyboardEvent) => {
      if (combinedList.length === 0) return;

      let nextIndex: number | null = null;
      if (e.code === "ArrowDown") nextIndex = Math.min(combinedList.length - 1, activeIndex + 1);
      else if (e.code === "ArrowUp") nextIndex = Math.max(0, activeIndex - 1);

      if (nextIndex !== null && nextIndex !== activeIndex) {
        requestAnimationFrame(() => {
          setActiveIndex(nextIndex!);
          itemRefs.current[nextIndex!]?.scrollIntoView({
            behavior: e.repeat ? "auto" : "smooth",
            block: "nearest",
          });
        });
        e.preventDefault();
      }

      if (e.code === "Enter" && activeIndex >= 0) {
        e.preventDefault();
        handleNavigate(combinedList[activeIndex].url || "");
      }
    },
    [activeIndex, combinedList, handleNavigate],
  );

  // Shared helper: compute route-matched tab name without triggering a re-render
  const getMatchedTabForCurrentRoute = () => {
    if (!Array.isArray(module)) return SELECTED_MODULE_ALL;
    const path = location.pathname.split("/").filter(Boolean);
    const parentRoute = path[1];
    if (!parentRoute) return SELECTED_MODULE_ALL;
    const matched = module.find((item) => {
      const normalizedItem = item?.mdl_key?.toLowerCase().replace(/\s+/g, "-");
      return normalizedItem === parentRoute.toLowerCase();
    });
    return matched ? (lang === LANG.english ? matched.en_name : matched.gu_name) : SELECTED_MODULE_ALL;
  };

  const handleTrigger = () => {
    // On mobile kirtan-lyrics page, skip the global modal — page handles search via IndexedDB
    if (isMobile && location.pathname.includes("kirtan-lyrics")) {
      requestAnimationFrame(() => {
        searchInputRef.current?.focus();
      });
      return;
    }

    // Set the correct tab BEFORE opening so both land in the same render.
    // Without this, the search effect fires once with the stale tab (extra API call)
    // and again after the route-matching useEffect updates the tab.
    dispatch(setSelectedTab(getMatchedTabForCurrentRoute()));

    setOpen(true);
    setRecentSearches(getRecentSearch() || []);
    resetTranscript();
    dispatch(setOpenToSearch(true));

    // Refocus input to ensure keyboard opens when panel opens
    requestAnimationFrame(() => {
      searchInputRef.current?.focus();
    });
  };

  useEffect(() => {
    if (!open) return;

    const path = location.pathname.split("/").filter(Boolean);
    const parentRoute = path[1];

    if (!parentRoute || !Array.isArray(module)) {
      dispatch(setSelectedTab(SELECTED_MODULE_ALL));
      return;
    }

    const matched = module.find((item) => {
      const normalizedItem = item?.mdl_key?.toLowerCase().replace(/\s+/g, "-");
      return normalizedItem === parentRoute.toLowerCase();
    });

    const matchedName = matched ? (lang === LANG.english ? matched.en_name : matched.gu_name) : SELECTED_MODULE_ALL;
    dispatch(setSelectedTab(matchedName));
  }, [open, location.pathname, module, lang]);

  // Auto-expand tabs if selectedTab is not in visible tabs
  useEffect(() => {
    const firstSixTabs = MODULE?.slice(0, 6);
    const isSelectedTabVisible = firstSixTabs?.includes(selectedTab);

    // If selectedTab is not in the first 6 tabs, expand to show all tabs
    if (!isSelectedTabVisible && selectedTab !== SELECTED_MODULE_ALL) {
      setShowAllTabs(true);
    }
  }, [selectedTab, MODULE]);

  // Clear tab button refs when visibleTabs changes
  useEffect(() => {
    tabButtonRefs.current = [];
  }, [visibleTabs?.length]);

  // Scroll to show selected tab when panel opens (for route-matched selection)
  useEffect(() => {
    if (!isMobile || !open || !tabsContainerRef.current || !selectedTab) return;

    const selectedTabIndex = visibleTabs?.indexOf(selectedTab);
    if (selectedTabIndex === -1 || selectedTabIndex === undefined) return;

    const selectedButton = tabButtonRefs.current[selectedTabIndex];
    if (!selectedButton) return;

    setTimeout(() => {
      selectedButton.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });

      requestAnimationFrame(() => {
        checkScrollPosition();
      });
    }, 150);
  }, [open, selectedTab, isMobile, checkScrollPosition]);

  // Check scroll position on initial mount and when tabs change
  useEffect(() => {
    if (!isMobile || !open) return;

    const container = tabsContainerRef.current;
    if (!container) return;

    // Initial check with delay to ensure DOM is rendered
    const initialTimer = setTimeout(() => {
      checkScrollPosition();
    }, 100);

    // Handle scroll events
    const handleScroll = () => {
      checkScrollPosition();
    };

    // Add scroll listener
    container.addEventListener("scroll", handleScroll, { passive: true });

    // Also check on window resize
    const handleResize = () => {
      checkScrollPosition();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      clearTimeout(initialTimer);
      container.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile, open, visibleTabs?.length, checkScrollPosition]);

  // keep searchText in sync with voice transcript
  useEffect(() => {
    if (searchType === "voice" && transcript) {
      const value = transcript.toLocaleLowerCase();
      dispatch(setSearchText(value));
      setActiveIndex(-1);
      addSearchParams(value);
      lastTranscriptRef.current = value;

      // Auto-stop listening on mobile after 500ms of silence or after 4+ words detected
      if (isMobile && speechStartTimeRef.current) {
        const elapsedTime = Date.now() - speechStartTimeRef.current;
        const wordCount = value.trim().split(/\s+/).length;

        // Stop if we have minimum 2 words and minimum 1 second has passed
        if (wordCount >= 2 && elapsedTime >= 1000) {
          try {
            SpeechRecognition.stopListening();
            if (speechTimeoutRef.current) {
              clearTimeout(speechTimeoutRef.current);
              speechTimeoutRef.current = null;
            }
          } catch (err) {
            console.error("Error stopping speech recognition:", err);
          }
        }
      }
    }
  }, [transcript, searchType, isMobile]);

  useEffect(() => {
    if (!open) return;

    // On mobile kirtan-lyrics page, skip API search — page handles it via IndexedDB
    if (isMobile && location.pathname.includes("kirtan-lyrics")) return;

    const normalizedSearchText = (searchText ?? "").trim();

    if (normalizedSearchText === "") {
      lastSearchRequestRef.current = "";
      resetFromTextBox();
      dispatch(setClearSearchResults());
      return;
    }

    const payload: QueryParams = {
      search_text: normalizedSearchText,
      limit: pageSize,
      pageNumber: pageLimit,
      module_name: selectedTab === SELECTED_MODULE_ALL ? null : selectedTab,
    };
    const requestKey = JSON.stringify(payload);

    const handler = setTimeout(() => {
      if (!isLoading && lastSearchRequestRef.current !== requestKey) {
        lastSearchRequestRef.current = requestKey;
        setPageDetails({ pageNumber: pageLimit, limit: pageSize });
        dispatch(getSearchResults(payload));
      }
    }, 200);

    return () => clearTimeout(handler);
  }, [open, isMobile, location.pathname, searchText, selectedTab, dispatch, SELECTED_MODULE_ALL]);

  useEffect(() => {
    if (!open) return;
    document.addEventListener("keydown", keyDownCallback);
    return () => document.removeEventListener("keydown", keyDownCallback);
  }, [open, keyDownCallback]);

  // Fetch modules on lang change
  useEffect(() => {
    dispatch(getSearchModule(lang || LANG.english));
    dispatch(setSelectedTab(SELECTED_MODULE_ALL));
    // dispatch(setSearchText(""));
  }, [lang, dispatch]);

  // Close on Escape

  function onEsc(e: KeyboardEvent) {
    if (e.key === "Escape") {
      onClose();
      dispatch(setClearSearchResults());
    }
  }

  useEffect(() => {
    if (!open) return;

    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [open, dispatch]);

  // Cleanup speech recognition on panel close and component unmount
  useEffect(() => {
    return () => {
      if (listening) {
        try {
          SpeechRecognition.stopListening();
        } catch (err) {
          console.error("Error stopping speech recognition on unmount:", err);
        }
      }
      if (speechTimeoutRef.current) {
        clearTimeout(speechTimeoutRef.current);
        speechTimeoutRef.current = null;
      }
    };
  }, [listening]);

  // Close panel when navigation completes
  useEffect(() => {
    if (navigationStatus.state === "idle") {
      onClose();
      // if (location.pathname !== location.pathname) {
      // }
    }
  }, [navigationStatus.state, location.pathname]);

  // Scroll to top when selected tab changes
  useEffect(() => {
    if (!searchResultsRef.current || !open) return;

    // Scroll only the results container to top, not the parent elements
    searchResultsRef.current.scrollTop = 0;
  }, [selectedTab, open]);

  // Disable body scroll when search panel is open
  useEffect(() => {
    if (open) {
      document.documentElement.classList.add("overflow-hidden");
      document.documentElement.style.overflow = "hidden";
      // document.body.classList.add("overflow-hidden");
    }

    return () => {
      document.documentElement.classList.remove("overflow-hidden");
      document.documentElement.style.removeProperty("overflow");
      document.body.classList.remove("overflow-hidden");
      setRecentSearches(getRecentSearch() || []);
      // document.body.style.removeProperty("overflow");
    };
  }, [open, isMobile]);

  const Footer = () =>
    isLoading ? (
      <div className="flex items-center justify-center h-16 text-gray-500">
        <CircularProgress size={24} />
      </div>
    ) : null;

  return (
    // <ClientOnly>
    // </ClientOnly>
    <div className="relative md:px-0 flex-1">
      <motion.div
        className={cn(
          width,
          className,
          "my-2 border-[1.5px] h-10 border-borderPrimary rounded-[30px] flex items-center py-3 px-[10px] bg-white cursor-text",
          open ? "ring-1 ring-primaryColor xs:w-[calc(100vw-30px)] px-[12px] transition-all duration-100 ease-in-out " : "",
          isMenu ? "ml-2" : "ml-0",
          isSticky ? "w-[calc(100vw-70px)] lg:w-[500px]" : "w-[calc(100vw-70px)] lg:w-[500px]",
        )}
        ref={triggerRef}
        onClick={handleTrigger}
      >
        {/* Left Section - Back arrow and Search icon */}
        <div className="flex items-center gap-x-2 flex-shrink-0">
          {open && (
            <span className="block lg:hidden">
              <IoMdArrowBack
                size={20}
                color={ICON_ORANGE_COLOR}
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}
              />
            </span>
          )}
          <span className={cn("flex items-center justify-center", open ? "xs:hidden md:block" : "block")}>
            <LuSearch size={20} color={ICON_ORANGE_COLOR} />
          </span>
        </div>

        {/* Center Section - Input field (takes full available width) */}
        <div className="flex-1 min-w-0 px-2">
          <input
            ref={searchInputRef}
            type="search"
            role="searchbox"
            aria-label="Search"
            value={searchText || ""}
            onChange={handleSearch}
            placeholder="Search"
            className={cn(
              "w-full border-none outline-none text-[16px] text-primaryColor placeholder:text-[14px] placeholder:font-normal placeholder:capitalize placeholder:text-textHeadingColor bg-transparent",
              normalInter,
            )}
            autoFocus={open}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            data-form-type="other"
            data-lpignore="true"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.currentTarget.blur();
              }
            }}
          />
        </div>

        {/* Right Section - Clear button and Mic button */}
        <div className="flex items-center gap-x-1 lg:gap-x-2 flex-shrink-0 ">
          {searchText && searchText.length > 0 && (
            <motion.button variants={touchVariants} initial="initial" whileTap="tap" onClick={handleClearSearch}>
              <MdOutlineClose size={22} color={COLORS.primary} />
            </motion.button>
          )}
          {/* Always render wrapper to prevent hydration mismatch */}
          <div className="relative">
            {voiceSearchSupported && (
              <>
                {listening && (
                  <motion.div
                    className="absolute inset-0 rounded-full bg-textHeadingColor z-0"
                    initial={{ scale: 0.9, opacity: 0.5 }}
                    animate={{
                      scale: [0.9, 1.2, 0.9],
                      opacity: [0.5, 0.25, 0.5, 0],
                    }}
                    transition={{ repeat: Infinity, duration: 1.2, ease: "easeInOut" }}
                  />
                )}

                <div className="relative z-50 p-1.5 flex items-center justify-center rounded-full">
                  <button onClick={listening ? handleStopVoiceSearch : handleMicClick}>
                    {isHydrated && listening ? (
                      <MdStop size={18} color={ICON_ORANGE_COLOR} />
                    ) : isHydrated ? (
                      <IoMdMic size={18} color={ICON_ORANGE_COLOR} />
                    ) : null}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </motion.div>
      {open && (
        <>
          {/* Navigation Loading Overlay */}
          {navigationStatus.state !== "idle" && (
            <motion.div
              className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/30 backdrop-blur-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
            >
              <motion.div initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.2, ease: "easeOut" }}>
                <CircularProgress
                  size={50}
                  sx={{
                    color: COLORS.iconOrange,
                  }}
                />
              </motion.div>
            </motion.div>
          )}

          {/* Backdrop */}
          <AnimatePresence>
            <motion.div
              className={cn(
                "fixed inset-0 top-28 md:top-36 lg:top-[4.8rem] bg-neutral-900/50 backdrop-blur-[0.1px] z-[9990] h-dvh overflow-y-visible",
                isMenu ? "top-36" : "",
                isSticky ? "top-28 lg:top-[4.4rem]" : "",
                isSupperHeader && supperHeader ? (isSticky ? "top-28 lg:top-[4.4rem]" : isMenu ? "top-36" : "!top-[10rem] md:!top-28") : "",
                isYoutubeVideoLayout && supperHeader ? "!top-[7.2rem]" : isYoutubeVideoLayout ? "!top-[4.6rem]" : "",
              )}
              onClick={onClose}
              onTouchMove={(e) => e.preventDefault()}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
            />
          </AnimatePresence>

          <div
            ref={panelRef}
            className={cn(
              "absolute top-[3.2rem] lg:top-11 xs:-left-[0.75rem] smd:-left-3 lg:left-auto lg:right-0 z-[9999] xs:w-dvw lg:!w-[500px] ",
              isMenu ? "xs:top-11 !right-0 !left-0" : "",
              isSticky ? "xs:!w-dvw  smd:!w-dvw lg:!w-[500px] lg:!top-[3.2rem] !right-0" : "",
            )}
          >
            <motion.div
              initial={{ opacity: 0, y: -6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.18, ease: "easeOut" }}
              className="rounded-b-2xl md:rounded-2xl shadow-xl border border-borderPrimary bg-white overflow-hidden "
            >
              <div
                className={cn(
                  isMobile ? "p-2" : "p-4",
                  "xs:h-dvh lg:min-h-[calc(100vh-500px)] lg:max-h-[calc(100vh-200px)] search-bar overflow-hidden",
                )}
              >
                <div className="w-full">
                  <div className="flex items-center gap-2 mb-4 pt-2 pb-5 border-b border-borderPrimary">
                    {/* Left Arrow - Mobile Only */}
                    {isMobile && canScrollLeft && (
                      <button
                        type="button"
                        tabIndex={-1}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (tabsContainerRef.current) {
                            tabsContainerRef.current.scrollBy({ left: -150, behavior: "smooth" });
                            // Re-check position after scroll
                            setTimeout(() => checkScrollPosition(), 500);
                          }
                        }}
                        onTouchStart={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (tabsContainerRef.current) {
                            tabsContainerRef.current.scrollBy({ left: -150, behavior: "smooth" });
                            setTimeout(() => checkScrollPosition(), 500);
                          }
                        }}
                        className="flex-shrink-0 text-primaryColor hover:text-primaryColor/80 transition"
                      >
                        <ChevronLeft size={18} />
                      </button>
                    )}

                    {/* Tabs Container */}
                    <div
                      ref={tabsContainerRef}
                      className={cn(
                        "flex gap-2 text-sm font-medium text-gray-600",
                        isMobile ? "overflow-x-auto flex-1 flex-nowrap scrollbar-hide" : "flex-wrap items-center flex-1",
                      )}
                    >
                      <AnimatePresence initial={false}>
                        {visibleTabs?.map((tab, index) => (
                          <motion.button
                            key={tab}
                            ref={(el) => (tabButtonRefs.current[index] = el)}
                            layout
                            tabIndex={-1}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            transition={{ duration: 0.2 }}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              onSelectedSearch(tab);
                            }}
                            className={cn(
                              "px-3 py-1.5 bg-cardBg rounded-full cursor-pointer text-textColor capitalize flex-shrink-0",
                              medium,
                              selectedTab === tab ? "bg-textHeadingColor text-white" : "hover:bg-cardBg",
                            )}
                          >
                            <p className="mt-0.5">{tab}</p>
                          </motion.button>
                        ))}
                      </AnimatePresence>

                      {/* Expand/Collapse Button - Desktop Only */}
                      {!isMobile && MODULE && MODULE?.length > 6 && showAllTabs ? (
                        <button
                          type="button"
                          tabIndex={-1}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowAllTabs(false);
                            requestAnimationFrame(() => {
                              searchInputRef.current?.focus();
                            });
                          }}
                          className={cn(
                            "text-sm text-primaryColor hover:text-primaryColor/80 transition bg-cardBg size-7 flex-shrink-0 flex items-center justify-center rounded-full",
                            medium,
                          )}
                        >
                          {/* {t("search.see_more")} */}
                          <ChevronDown className="mt-0.5" />
                        </button>
                      ) : (
                        !isMobile && (
                          <button
                            type="button"
                            tabIndex={-1}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setShowAllTabs(true);
                              requestAnimationFrame(() => {
                                searchInputRef.current?.focus();
                              });
                            }}
                            className={cn(
                              "text-sm text-primaryColor hover:text-primaryColor/80 transition bg-cardBg size-7 flex-shrink-0 flex items-center justify-center rounded-full",
                              medium,
                            )}
                          >
                            {/* {t("search.see_less")} */}
                            <ChevronUp className="md:mb-0.5" />
                          </button>
                        )
                      )}
                    </div>

                    {/* Right Arrow - Mobile Only */}
                    {isMobile && canScrollRight && (
                      <button
                        type="button"
                        tabIndex={-1}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (tabsContainerRef.current) {
                            tabsContainerRef.current.scrollBy({ left: 150, behavior: "smooth" });
                            // Re-check position after scroll
                            setTimeout(() => checkScrollPosition(), 500);
                          }
                        }}
                        onTouchStart={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (tabsContainerRef.current) {
                            tabsContainerRef.current.scrollBy({ left: 150, behavior: "smooth" });
                            setTimeout(() => checkScrollPosition(), 500);
                          }
                        }}
                        className="flex-shrink-0  text-primaryColor hover:text-primaryColor/80 transition"
                      >
                        <ChevronRight size={18} />
                      </button>
                    )}
                  </div>

                  {/* Results */}
                  {/* <div className="space-y-2 h-[calc(100vh-250px)] search-result overflow-y-auto overflow-x-hidden"> */}
                  <div
                    ref={searchResultsRef}
                    className={cn(
                      "space-y-2 h-[calc(100dvh-200px)] overflow-y-auto overflow-x-hidden",
                      showAllTabs ? "lg:h-[calc(100dvh-400px)]" : "lg:h-[calc(100dvh-350px)]",
                      isSticky ? "search-result-sticky" : "search-result",
                    )}
                  >
                    {recentSearches.length > 0 && searchText === "" && (
                      <div>
                        <span className="text-sm text-start text-gray-500">Recent Searches</span>
                        {recentSearches.map((item, idx) => (
                          <li
                            key={idx}
                            ref={(el) => (itemRefs.current[idx] = el)}
                            className={cn(
                              "flex items-center justify-between px-4 py-2 rounded-lg hover:bg-cardBg cursor-pointer transition",
                              activeIndex === idx ? "bg-cardBg" : "hover:bg-cardBg",
                              navigationStatus.state !== "idle" && "opacity-50 pointer-events-none",
                            )}
                            onClick={() => {
                              window.closeSheet?.();
                              navigate(item.url);
                            }}
                          >
                            <div className="flex items-center justify-between w-full">
                              <div className="flex items-center gap-3">
                                <div>
                                  <ListImage url={item.image || FALLBACK_IMAGE_URL} alt={item.name} />
                                </div>
                                <div>
                                  <div
                                    className={cn(
                                      "font-medium text-sm line-clamp-1 text-textColor tracking-wide capitalize overflow-hidden",
                                      normalInter,
                                    )}
                                  >
                                    {truncateString(item.name, 60)}
                                  </div>
                                  <div
                                    className={cn("text-xs font-inter line-clamp-1 capitalize text-textHeadingColor overflow-hidden", normalInter)}
                                  >
                                    {removeUnderscore(item.module)}
                                  </div>
                                </div>
                              </div>
                              <button>
                                <MdOutlineClose size={20} color={COLORS.primary} onClick={(e) => handleClearRecentSearches(e, item)} />
                              </button>
                            </div>
                          </li>
                        ))}
                      </div>
                    )}

                    {hasResults ? (
                      <SearchList
                        data={listData}
                        lang={lang || LANG.english}
                        activeIndex={activeIndex}
                        itemRefs={itemRefs}
                        handleApplySearch={handleApplySearch}
                        loadMore={loadMore}
                        Footer={Footer}
                        showNote={showNoResultsNote}
                        moduleTab={selectedTab}
                        isLoading={isLoading}
                        isNavigating={navigationStatus.state !== "idle"}
                        search={searchText || ""}
                      />
                    ) : isLoading ? (
                      <div className="space-y-1">
                        {Array.from({ length: 8 }).map((_, idx) => (
                          <ul key={idx}>
                            <li className="flex items-center justify-between px-4 py-2 rounded-lg">
                              <div className="flex items-center gap-3 w-full">
                                <div className="w-10 h-10 bg-gray-200 rounded-lg animate-pulse"></div>
                                <div className="flex-1">
                                  <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-3/4"></div>
                                  <div className="h-3 bg-gray-200 rounded animate-pulse w-1/2"></div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        ))}
                      </div>
                    ) : (
                      <>
                        {recentSearches.length <= 0 && searchText?.length === 0 ? (
                          <div className="overflow-y-hidden">
                            <p className={cn("text-sm text-center text-gray-500 py-4 capitalize", normalInter)}>
                              {t("search.find_search_results", { query: MODULE?.filter((item) => item !== SELECTED_MODULE_ALL).join(", ") })}
                            </p>
                          </div>
                        ) : (
                          searchResults?.rows?.length === 0 &&
                          allModule?.rows?.length === 0 &&
                          searchText &&
                          searchText?.length > 0 && (
                            <div className="overflow-y-hidden">
                              <p className={cn("text-sm text-center text-gray-500 py-4 capitalize", normalInter)}>
                                {t("search.search_results_not_found", { query: MODULE?.filter((item) => item !== SELECTED_MODULE_ALL).join(", ") })}
                              </p>
                            </div>
                          )
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchBar;
